export default __webpack_public_path__ + "locales/nl/ResetApplicationDialog.json?hash=2c77eff2a25cb40b0ef6626306402d6b";